module.exports = __webpack_public_path__ + "img/1.8685ad38.jpg";